module.exports = __webpack_public_path__ + "img/nodata2.ea2944e9.png";